export const NORMAL_SECTION_TYPE_ID = 10;
export const MULTIPLE_ENTRY_SECTION_TYPE_ID = 11;